"use client";
import ListPage from "@/components/ui/ListPage";
import PostCard from "@/components/blog/PostCard";
import { fetchDataAndMeta } from "@/lib/clientFetchers/fetchDataAndMeta";

export default function CategoryPostsClientPage({
    categorySlug,
    initialPosts = [],
    initialQ = "",
    initialMeta = {},
}) {
    const fetchCategoryPosts = (q, page = 1, limit = 12) =>
        fetchDataAndMeta({
            type: "categoryPosts",
            categorySlug,
            q,
            page,
            limit,
        });

    return (
        <ListPage
            fetchData={fetchCategoryPosts}
            Card={PostCard}
            title={`Posts in ${categorySlug} – Category`}
            placeholder={`Search posts in ${categorySlug}…`}
            breadcrumbs={[
                { label: "Home", href: "/" },
                { label: "Categories", href: "/categories" },
                { label: categorySlug },
            ]}
            initialData={initialPosts}
            initialMeta={initialMeta}
            initialQ={initialQ}
            cardPropName="post"
        />
    );
}
